<button [class.full-width]="full" [class.button-disabled]="disabled" [disabled]="disabled" mat-button
    [ngClass]="{'flat': type === 'flat', 'primary' : type === 'primary', 'black': type === 'black', 'column-visibility': type === 'column-visibility' }"
    [style]="customStyle">
    {{text | translate}}
</button>
